export default __webpack_public_path__ + "static/media/chooseYourArea.b3b6d43d.png";